import { Country } from '@afterpay/types'

// Undefined type is only used to satisfy TS complaining about using `.includes` with `undefined`
export const COUNTRIES_WITH_BILLING_ADDRESS_REQUIREMENTS: Array<Country | undefined> = [Country.GB, Country.US, Country.CA]
